import React from "react"
import PropTypes from "prop-types"

const GeneralError = ({content}) => (
  <div>{content}</div>
)

GeneralError.propTypes = {
  content: PropTypes.string
}

const Conflict = ({content}) => {
  return (
    <div>
      Reservation conflicts:
      <ul>
        {content.map(({name, time}, index) =>
          <li key={index}>
            <span>{name}</span>
            <span>{time}</span>
          </li>
        )}
      </ul>
    </div>
  )
}

Conflict.propTypes = {
  content: PropTypes.array
}

const ErrorFields = ({errors}) => {
  if (!errors) return null
  return (
    <div className="edit-recurring-errors">
      {Object.keys(errors).map(errorKey =>
        errorKey == "conflicts"
        ? <Conflict key={errorKey} content={errors[errorKey]} />
        : <GeneralError key={errorKey} content={errors[errorKey]} />
      )}
    </div>
  )
}

ErrorFields.propTypes = {
  errors: PropTypes.object
}

export default ErrorFields
